// GAVION A10: Profil → « Changer le mot de passe » (changement sur place, sans courriel).
export const profilePasswordFr = {
  button: "Changer le mot de passe",
  title: "Changer le mot de passe",
  new_password: "Nouveau mot de passe",
  confirm_password: "Confirmer le mot de passe",
  hint: "Au moins %{min} caractères.",
  cancel: "Annuler",
  save: "Enregistrer",
  success: "Mot de passe mis à jour.",
  microsoft_only:
    "Vous vous connectez avec Microsoft : votre mot de passe se gère dans Microsoft 365.",
  errors: {
    too_short: "Le mot de passe doit contenir au moins %{min} caractères.",
    mismatch: "Les mots de passe ne correspondent pas.",
    same_password: "Choisissez un mot de passe différent de l'actuel.",
    weak_password:
      "Mot de passe trop faible. Choisissez-en un plus long ou moins courant.",
    reauthentication_needed:
      "Par sécurité, déconnectez-vous puis reconnectez-vous avant de changer votre mot de passe.",
    session_expired: "Votre session a expiré. Reconnectez-vous puis réessayez.",
    unknown: "Le mot de passe n'a pas pu être changé. Réessayez.",
  },
};
